module.exports = __webpack_public_path__ + "media/src/website/images/locations/oberschleissheim/03-f4a28f0f3afdf878c6861643358bc49c.jpg";